import { useElapsedSince } from '../../../shared/hooks/useElapsedSince'
import { formatDurationDe } from '../../../shared/lib/durationDe'

interface Props {
  /** ISO `schedule.actualWorkStartsAt`. */
  actualStart: string | null
}

/**
 * The read-only "this is what will be saved" line of the confirmation-first complete
 * dialogs: start wall-clock time plus a live duration. The null branch is defensive —
 * completing is only offered while in progress, so a start should always exist.
 */
export function WorkTimeSummary({ actualStart }: Props) {
  const startMs = actualStart ? new Date(actualStart).getTime() : null
  const ageMs = useElapsedSince(startMs)

  if (startMs === null || ageMs === null) {
    return <p className="text-sm text-gray-600">Die Arbeitszeit wird beim Abschließen erfasst.</p>
  }

  const startLabel = new Date(startMs).toLocaleTimeString('de-DE', {
    hour: '2-digit',
    minute: '2-digit',
  })

  return (
    <p className="text-sm text-gray-600">
      Gestartet um {startLabel} Uhr
      <span className="mx-1.5" aria-hidden="true">
        ·
      </span>
      Dauer:{' '}
      <span className="font-medium text-gray-900 tabular-nums">
        {formatDurationDe(Math.floor(ageMs / 60_000))}
      </span>
    </p>
  )
}
